<template>
  <ul v-if="merchants.length > 0" class="space-y-2">
    <li v-for="merchant in merchants" :key="merchant.id">
      <div
        class="grid grid-cols-6 content-center gap-2 rounded-lg border border-background-fg/8 px-4 py-2 shadow-sm md:grid-cols-12"
      >
        <div
          class="col-span-3 flex flex-col items-start justify-center font-semibold"
        >
          {{ merchant.name }}
          <div
            class="text-xs font-medium text-background-fg/70"
            >{{ merchant.tpReference || "-" }}</div
          >
        </div>

        <div
          class="col-span-3 flex items-center text-xs text-background-fg/70"
        >
          Total Transactions:
          <br />
          {{
            formatToCurrencyString(
              merchant.transactionTotal,
              merchant.currency
            ) || "-"
          }}
        </div>

        <div
          class="col-span-3 flex items-center text-xs text-background-fg/70"
        >
          Last transacted:
          <br />
          {{
            merchant.lastTransactedAt
              ? DateFns.formatDistance(
                  typeof merchant.lastTransactedAt ===
                    "string"
                    ? DateFns.parseISO(
                        merchant.lastTransactedAt
                      )
                    : merchant.lastTransactedAt,
                  now,
                  { addSuffix: true }
                )
              : "-"
          }}
        </div>

        <div
          class="col-span-3 flex items-center text-xs text-background-fg/70"
        >
          Product(s) used:
          <br />
          {{ merchant.sources?.at(0) ?? "None" }}
        </div>
      </div>
    </li>
  </ul>

  <p v-else class="text-center"
    >No merchants associated with this merchant group</p
  >
</template>

<script setup lang="ts">
import type { MerchantGroupMerchant } from "@/services/merchants/retrieveMerchantGroup"

defineProps<{
  merchants: Array<MerchantGroupMerchant>
}>()

const now = useNow()
</script>
